import React from 'react';
import { CacheKeys, NotFound, useModulePermission } from '@bechtel/client-common';
import { RodRoomList } from './list';
import { RodRequests } from './request';
import { useRodRoomPermissions } from '@bechtel/client-weld-common';
import { Alert } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RodRoomContextProvider } from './utilities/context';

const RodRoom = () => {
  const { canViewRodRoom } = useRodRoomPermissions();
  const { canViewRodRoomModule } = useModulePermission();
  if (!canViewRodRoomModule)
    return (
      <Alert>
        <Trans>Sorry, Rod Room module is not activated for this project.</Trans>
      </Alert>
    );
  if (!canViewRodRoom)
    return (
      <Alert>
        <Trans>Sorry, you do not have permission to view rod room</Trans>
      </Alert>
    );

  //TODO: useSessionStorage hook not returning stored value
  // const selectedRodRoom = useSessionStorage<RodRoom>(CacheKeys.SelectedRodRoom)[0];
  const selectedRodRoom = window.sessionStorage.getItem(CacheKeys.SelectedRodRoom);
  return (
    <RodRoomContextProvider>
      <Routes>
        <Route path="/" element={selectedRodRoom ? <Navigate to="/rod-room/requests" /> : <RodRoomList />} />
        <Route path="/requests/*" element={<RodRequests />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </RodRoomContextProvider>
  );
};

export default RodRoom;
